import { render } from "./DRPieChart.vue?vue&type=template&id=851701a8"
import script from "./DRPieChart.vue?vue&type=script&lang=js"
export * from "./DRPieChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__